import { useQuery } from "@tanstack/react-query"
import { useEffect } from "react"

import { api } from "@/lib/axios"
import { useAuthStore } from "@/features/auth/store/auth-store"

import { useCompanyStore, type Company } from "../store/company-store"

// A função que efetivamente faz a chamada à API
async function getCompany(companyId: string): Promise<Company> {
  const response = await api.get<Company>(`/company/${companyId}`)
  return response.data
}

export function useCompanyQuery() {
  const { user } = useAuthStore()
  const { setCompany } = useCompanyStore()

  const companyId = user?.company

  const query = useQuery({
    // A chave da query identifica unicamente esta busca de dados.
    queryKey: ["company", companyId],

    // A função que será executada para buscar os dados.
    // O '!' é seguro aqui por causa da verificação `enabled` abaixo.
    // A queryFn só é definida se companyId existir, evitando o uso de '!'
    queryFn: () =>
      companyId ? getCompany(companyId) : Promise.reject(new Error("Company ID is missing")),

    // A query só será executada se `companyId` for um valor "truthy".
    enabled: !!companyId,
  })

  useEffect(() => {
    if (query.data) {
      setCompany(query.data)
    }
  }, [query.data, setCompany])

  return query
}